import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { DealAssistantEntry } from '@makemydeal/dr-dash-deal-assistant';

export const useDealAssistantEntry = (): ReactNode => {
    const isEnabled = useSelector(dealerSelectors.isDealAssistantEnabled);
    return isEnabled ? <DealAssistantEntry /> : undefined;
};
